import { render, staticRenderFns } from "./SftpStatus.vue?vue&type=template&id=68426c53&"
import script from "./SftpStatus.vue?vue&type=script&lang=js&"
export * from "./SftpStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports